import types from './types'

export const getUserDetails = () => ({
    type: types.GET_USER_DETAILS
})

